import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const zones = [
  "Villeurbanne", "Vénissieux", "Bron",
  "Vaulx-en-Velin", "Oullins",
  "Saint-Priest", "Décines-Charpieu", "Meyzieu",
  "Brignais", "Genas", "Chassieu",
  "Rillieux-la-Pape",
  "Givors", "Corbas", "Pierre-Bénite",
];

const zoneSlug = (zone) =>
  zone
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const Zones = () => {
  return (
    <section id="zones" className="relative py-28 lg:py-40 overflow-hidden" data-testid="zones-section">
      <span
        className="pointer-events-none select-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-display font-black uppercase text-[26vw] leading-none text-transparent opacity-[0.05] whitespace-nowrap"
        style={{ WebkitTextStroke: "1px rgba(0,85,255,0.12)" }}
        aria-hidden="true"
      >
        LYON
      </span>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <motion.p
          className="text-xs uppercase tracking-[0.35em] text-[#0055FF] mb-6"
        >
          Zones d'intervention
        </motion.p>
        <motion.h2
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight uppercase text-zinc-950 mb-8"
        >
          Lyon <span className="text-chrome">et sa métropole</span>
        </motion.h2>
        <motion.p
          className="max-w-2xl text-base md:text-lg font-light text-zinc-600 mb-16"
        >
          Réparation de téléphone à domicile à Lyon et dans toutes les communes
          alentour : notre technicien se déplace chez vous ou à votre bureau,
          de 10h à 23h, 7 jours sur 7.
        </motion.p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {zones.map((zone, i) => {
            const card = (
              <>
                <MapPin className="h-4 w-4 shrink-0 text-zinc-600 group-hover:text-[#0055FF] transition-colors duration-300" />
                <span className="text-sm md:text-base font-medium tracking-wide text-zinc-700 group-hover:text-zinc-950 transition-colors duration-300">
                  {zone}
                </span>
              </>
            );
            const cardClass =
              "group flex items-center gap-3 border border-zinc-200 bg-white px-6 py-5 hover:border-[#0055FF]/60 hover:bg-[#0055FF]/5 transition-colors duration-400";
            const testId = `zone-card-${zone.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
            return (
              <a key={zone} href={`/reparation-telephone-${zoneSlug(zone)}`} className={cardClass} data-testid={testId}>
                {card}
              </a>
            );
          })}
        </div>

        <motion.p
          className="mt-12 text-base font-light text-zinc-900"
          data-testid="zones-deplacement-offert"
        >
          Déplacement offert.
        </motion.p>
      </div>
    </section>
  );
};
